import { render } from "./TaxEditModal.vue?vue&type=template&id=83c9fdc6&scoped=true&ts=true"
import script from "./TaxEditModal.vue?vue&type=script&lang=ts"
export * from "./TaxEditModal.vue?vue&type=script&lang=ts"

import "./TaxEditModal.vue?vue&type=style&index=0&id=83c9fdc6&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/saas-settlement-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83c9fdc6"]])

export default __exports__